
export default {
	name: "LoadingSpinner",
	props: {
		label: {
			type: String,
			default: "Loading…",
		},
	},
};
